import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { ShareBetResponseModel } from 'models';
import { ChatMessageType } from 'models/chatMessage';

export interface ChatState {
  replyMessage: ChatMessageType | null;
  followBet: ShareBetResponseModel | null;
  showChatMobile: boolean | null;
  showChatDesktop: boolean | null;
}

const initialState: ChatState = {
  replyMessage: null,
  followBet: null,
  showChatMobile: false,
  showChatDesktop: false, 
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setReplyMessage: (state, action: PayloadAction<ChatMessageType>) => {
      state.replyMessage = action.payload;
    },
    clearReplyMessage: (state) => {
      state.replyMessage = null;
    },
    setFollowBet: (state, action: PayloadAction<ShareBetResponseModel>) => {
      state.followBet = action.payload;
    },
    clearFollowBet: (state) => {
      state.followBet = null;
    },
    setShowChatMobile: (state, action: PayloadAction<boolean>) => {
      state.showChatMobile = action.payload;
    },
    setShowChatDesktop: (state, action: PayloadAction<boolean>) => {
      state.showChatDesktop = action.payload;
    },
  },
});

export const {
  setReplyMessage,
  clearReplyMessage,
  setFollowBet,
  clearFollowBet,
  setShowChatMobile,
  setShowChatDesktop,
} = chatSlice.actions;

export const selectReplyMessage = (state: RootState) => state.chat.replyMessage;
export const selectFollowBet = (state: RootState) => state.chat.followBet;
export const selectShowChatMobile = (state: RootState) => state.chat.showChatMobile;
export const selectShowChatDesktop = (state: RootState) => state.chat.showChatDesktop;
// NOTE: Reducer
export default chatSlice.reducer;
